import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/gascaribe',
          role: 'get_invoices_gascaribe',
        },
        gasguajira: {
          path: '/gasguajira',
          role: 'get_invoices_gasguajira',
        },
        efigas: {
          path: '/efigas',
          role: 'get_invoices_efigas',
        },
      }}
    />
  );
};

export default Home;
